import __request__ from "routing/request";
export function getPage(collection, identifier = "_id", column = "title", display_fields, display_template, identifier_type = "OBJECT_ID", page = 1, per_page = 10, query, requestOptions) {
  return __request__("GET", "/entity_suggestions", null, { "collection": collection, "identifier": identifier, "column": column, "display_fields": display_fields, "display_template": display_template, "identifier_type": identifier_type, "page": page, "per_page": per_page, "query": query }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
